// extracted by css-extract-rspack-plugin
export default {"cls1":"SourceText-cls1_dA8","cls2":"SourceText-cls2_7gJ SourceText-cls1_dA8"};